<template>
    <div class="encabezado">
        <div class="encabezado__banda">
            <div class="encabezado__avatar" aria-hidden="true">{{ iniciales }}</div>
            <div class="encabezado__textos">
                <h1 class="encabezado__saludo">Hola, {{ nombreCorto }}</h1>
                <div class="encabezado__subtitulo">{{ subtitulo }}</div>
            </div>
            <div class="encabezado__ayuda">
                <tutorial-video variante="oscuro"/>
            </div>
        </div>

        <nav class="encabezado__secciones" aria-label="Secciones">
            <router-link v-for="s in secciones" :key="s.ruta" :to="{name: s.ruta}" class="encabezado__seccion" active-class="encabezado__seccion--activa">
                <v-icon small>{{ s.icono }}</v-icon> {{ s.texto }}
            </router-link>
        </nav>

        <div class="encabezado__cifras" v-if="cifras.length">
            <div class="encabezado__cifra" v-for="cifra in cifras" :key="cifra.etiqueta">
                <v-icon class="encabezado__cifra-icono">{{ cifra.icono }}</v-icon>
                <div>
                    <div class="encabezado__cifra-valor">{{ cifra.valor }}</div>
                    <div class="encabezado__cifra-etiqueta">{{ cifra.etiqueta }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Ls from "@/services/ls";
import TutorialVideo from "@/components/Ayuda/TutorialVideo.vue";

/**
 * Saludo del participante con su resumen. Lo comparten "Mis cursos" y "Constancias".
 *
 *   cifras: [{icono: 'school', valor: 3, etiqueta: 'Cursos aprobados'}]
 */
export default {
    name: "MisCursosEncabezado",
    components: {TutorialVideo},
    props: {
        subtitulo: {type: String, default: ""},
        cifras: {type: Array, default: () => []},
    },
    data() {
        return {
            secciones: [
                {ruta: "MisCursosHistorial", icono: "history", texto: "Historial"},
                {ruta: "MisCursosConstancias", icono: "description", texto: "Constancias"},
            ],
            nombre: this.limpio(Ls.get("nombre")),
            apellido: this.limpio(Ls.get("apellido")),
        }
    },
    computed: {
        // Primer nombre y primer apellido, con mayúscula inicial (en la base vienen en mayúsculas).
        nombreCorto() {
            const partes = [this.nombre.split(" ")[0], this.apellido.split(" ")[0]].filter(Boolean);
            if (!partes.length) return "participante";
            return partes.map(p => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase()).join(" ");
        },
        iniciales() {
            const letras = (this.nombre.charAt(0) + this.apellido.charAt(0)).toUpperCase();
            return letras || "•";
        },
    },
    methods: {
        limpio(valor) {
            return (valor && valor !== "null" ? String(valor) : "").trim();
        },
    },
}
</script>

<style lang="scss" scoped>
.encabezado {
    margin-bottom: 20px;
}

.encabezado__banda {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    padding: 22px 24px;
    border-radius: 14px;
    background: #203d89;
    color: #fff;
}

.encabezado__avatar {
    width: 54px;
    height: 54px;
    flex: none;
    border-radius: 50%;
    background: #d29e4a;
    color: #1b2340;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 1.15rem;
    letter-spacing: .02em;
}

.encabezado__textos {
    flex: 1;
    min-width: 200px;
}

.encabezado__saludo {
    margin: 0 !important;
    font-size: 1.45rem !important;
    line-height: 1.25 !important;
    font-weight: 700;
    color: #fff;
}

.encabezado__subtitulo {
    margin-top: 2px;
    font-size: .92rem;
    color: rgba(255, 255, 255, .78);
}

.encabezado__ayuda ::v-deep .tutorial__boton {
    margin-bottom: 0;
}

.encabezado__secciones {
    display: flex;
    gap: 6px;
    margin-top: 12px;
}

.encabezado__seccion {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 7px 16px;
    border-radius: 999px;
    background: #fff;
    border: 1px solid #cfd6ea;
    color: #454d6b;
    font-size: .85rem;
    font-weight: 600;
    text-decoration: none;

    .v-icon { color: inherit; }

    &:hover { border-color: #203d89; color: #203d89; }

    &--activa {
        background: #203d89;
        border-color: #203d89;
        color: #fff;
    }
}

.encabezado__cifras {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
    gap: 12px;
    margin-top: 12px;
}

.encabezado__cifra {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    border-radius: 12px;
    background: #fff;
    border: 1px solid #e3e7f2;
}

.encabezado__cifra-icono {
    color: #203d89 !important;
    background: #eaeefa;
    border-radius: 10px;
    padding: 8px;
}

.encabezado__cifra-valor {
    font-size: 1.35rem;
    font-weight: 700;
    line-height: 1.2;
    color: #1b2340;
    font-variant-numeric: tabular-nums;
}

.encabezado__cifra-etiqueta {
    font-size: .8rem;
    color: #5b6380;
}

@media (max-width: 600px) {
    .encabezado__banda {
        padding: 18px 16px;
    }

    .encabezado__ayuda {
        width: 100%;
    }
}
</style>
